export const radioQuestions = [
  {
    questionHeader: "Please select your gender",
    options: [
      {
        label: "Male",
      },
      {
        label: "Female",
      },
      {
        label: "Other",
      },
    ],
  },
  {
    questionHeader: "1. Which phase describes you the best?",
    options: [
      {
        label:
          "I have a skill/passion just want to know how to monetize by making it valuable to others",
      },
      {
        label:
          "I'm confused and I feel stuck. I don't know which skill to exactly to focus on that could generate consistent income",
      },
      {
        label:
          "I'm not serious at the moment. Just playing around to see what works the best",
      },
    ],
  },
  {
    questionHeader:
      "2. What's your goal that you are trying to achieve as an aspiring entrepreneur/business owner/freelancer (figures = INR*) [6 Figures - 1L - 9.9L INR*, 7 Figures - 10L - 99L INR*]",
    options: [
      {
        label:
          "To start generating 6 to 7 figures a year so I'm self sufficient and don't have to depend on anyone for my fulfil my financial needs/wants ",
      },
      {
        label:
          "I'm already making 5 to 6 figures I want to scale it to 7 figures ",
      },
      {
        label: "I don't have any goals yet. ",
      },
    ],
  },
  {
    questionHeader:
      "3. What's the missing bridge between your present situation and the goals you are trying to achieve? ",
    options: [
      {
        label:
          "I want someone experienced and credible to help me and guide in terms of monetising my passion/skills into profits. ",
      },
      {
        label:
          "I don't have access to the information and knowledge that would help me achieve my goals. I need clarity and will figure it by my own",
      },
      {
        label: "I'm smart but just too lazy to take action.",
      },
    ],
  },
  {
    questionHeader:
      "4. Have you been part of any college clubs? If yes, what has your experience been so far? ",
    options: [
      {
        label:
          "It's just good for building a network but nothing to learn from it as no one is serious or experienced enough.",
      },
      {
        label:
          "It is valuable but doesn't provide you with any insights on how to implement or turn my existing skills into lucrative money making business that's valuable to the marketplace. Need more clarity on how to do it. ",
      },
      {
        label: "I don't pay attention I have no clue",
      },
    ],
  },
  {
    questionHeader:
      "5. If Formi Had to come up with an exclusive event to help you achieve your financial goals and give a clear idea on generating 6 to 7 figures in your teens or early 20s learning from one of the best in the industry. Would you like to be notified about that event and interested in being part of it? (It's going to be FREE, no Opts-ins, no upsells) ",
    options: [
      {
        label:
          "If it's from an experienced entrepreneur where I can receive value and level up my skills, then YES!",
      },
      {
        label:
          "No, I wouldn't be interested as it's not a priority for me at the moment",
      },
    ],
  },

  {
    questionHeader:
      "6. This is not a magic wand, it does require hard work and consistency. Are you ready invest your time and energy into this?",
    options: [
      {
        label: "Yes, I am ready",
      },
      {
        label: "No, I'm not ready",
      },
    ],
  },
  {
    questionHeader:
      "7. Would you like to be a part of Formi's marketing team? (Paid Internship)",
    options: [
      {
        label: "Yes, I am interested",
      },
      {
        label: "No, not interested",
      },
    ],
  },
];

export const checkQuestions = [
  {
    questionNumber: 1,
    questionHeader: "1. What kind of events are you interested in?",
    options: [
      {
        label: "Commercial EDM",
      },
      {
        label: "Hip-Hop",
      },
      {
        label: "Bollywood",
      },
      {
        label: "Techno",
      },
      {
       label:"Others"
      }
    ],
  },
  {
    questionNumber: 2,
    questionHeader:
      "2. What is the most convenient time for you to attend an event?",
    options: [
      {
        label: "Afternoon (12pm-4pm)",
      },
      {
        label: "Evening (4pm-8pm)",
      },
      {
        label: "Night (9pm-1am)",
      },
    ],
  },
  {
    questionNumber: 3,
    questionHeader: "3. What days do you prefer?",
    options: [
      {
        label: "Weekdays (Monday, Tuesday, Wednesday, Thursday)",
      },
      {
        label: "Weekends (Friday, Saturday, Sunday)",
      },
    ],
  },
  {
    questionNumber: 4,
    questionHeader: "4. What appeals to you the most in a party?",
    options: [
      {
        label: "A teriffic DJ",
      },
      {
        label: "Prodution",
      },
      {
        label: "Venue",
      },
    {
      label: "Crowd"
    }
    ],
  },
];
